import { Grid, IconButton, Typography } from "@mui/material";
import React from "react";
import ExpandCircleDownIcon from "@mui/icons-material/ExpandCircleDown";
import { scrollToPosition } from "../utils/scrollUtils";
const Hero = ({ image, text, scrollPosition }) => {
  const handleHeroButtonClick = () => {
    scrollToPosition(scrollPosition);
  };
  return (
    <Grid container sx={{ backgroundColor: "appBlue.dark" }}>
      <Grid
        item
        xs={12}
        // md={12}
        sx={{
          "& img": { maxHeight: "500px", objectFit: "cover", display: "flex" },
        }}
      >
        <img src={image} alt="Used cars at exciting price" width="100%" />
      </Grid>
      {/* <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: "2rem",
            color: "#fff",
            textAlign: "center",
            maxWidth: "75%",
            margin: "1rem 0",
          }}
        >
          {text}
        </Typography>
        <IconButton
          sx={{ color: "#fff", margin: "1rem 0" }}
          size="large"
          onClick={handleHeroButtonClick}
        >
          <ExpandCircleDownIcon sx={{ fontSize: 32 }} />
        </IconButton>
      </Grid> */}
    </Grid>
  );
};

export default Hero;
